import React from 'react';
import SupplierForm  from '../components/Supplier_Form';
import { Row, Col, Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';

const Supplierform = () => {
  
  return (
    <div style={{ padding: '0px 0px 0px 20px' }}>
      <h3>Cadastro Empresa</h3>
        <Breadcrumb style={{ marginBottom: 16 }}>
          <Breadcrumb.Item>
            <Link to="/">Início</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/supplier">Clientes</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Formulário</Breadcrumb.Item>
        </Breadcrumb>
      <Row>
        <Col
          xs={0} // Esconde em dispositivos pequenos
          sm={0} // Esconde em dispositivos médios
          md={24} // Mostra em dispositivos maiores ou iguais a 'md'
        >
          <SupplierForm />
        </Col>
        <Col
          xs={24} // Esconde em dispositivos pequenos
          sm={24} // Esconde em dispositivos médios
          md={0} // Mostra em dispositivos maiores ou iguais a 'md'
        >
          <SupplierForm />
        </Col>
      </Row>
    </div>
  );
};

export default Supplierform;